import { analytics, AnalyticsUiAction, AnalyticsUiSubject } from '@atlassian/temp-analytics';
import { ORGANIZATION_PATH } from '@atlassian/cssxp-typescommon';
import * as React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/atlassian-access-link.scss';
import AtlassianAccessIcon from '../../assets/img/icon-identity-manager.svg';
import { getCASSIBaseURL } from '../../security';

interface Props {
  organizationId: string;
  hideIcon?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const AtlassianAccessLink = ({
  organizationId,
  hideIcon,
  onClick = () => {
    /* stub */
  },
}: Props) => (
  <Link
    target="_blank"
    to={{ pathname: `${getCASSIBaseURL()}${ORGANIZATION_PATH}/${organizationId}` }}
    data-testid="atlassian-access-link"
    onClick={(event) => {
      onClick(event);

      analytics.sendUIEvent({
        action: AnalyticsUiAction.CLICKED,
        actionSubject: AnalyticsUiSubject.LINK,
        actionSubjectId: 'atlassianAccessLink',
      });
    }}
  >
    {!hideIcon && (
      <React.Fragment>
        {/* @ts-ignore */}
        <img src={AtlassianAccessIcon} className="atlassianAccessIcon" data-testid="atlassian-access-icon" />{' '}
      </React.Fragment>
    )}
    Atlassian Access
  </Link>
);

export default AtlassianAccessLink;
